const compare = require('./compare')
const lte = (a, b, loose) => compare(a, b, loose) <= 0
module.exports = lte



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/lte.js
// module id = 382
// module chunks = 0